var TrilliumPageHistoryState = (function ($) {

    var containerSelector = ".trillium-page-history-state";

    var checkIfContainerOrHashExists = function () {
        if (window.location.hash !== '' ||
            ($(containerSelector) !== null &&
                $(containerSelector).length)) {
            return true;
        }
        return false;
    };

    var updatePageHistoryState = function () {

        var container = $(containerSelector);
        var newHistoryStatePath = container.data("page-history-state-path");
        var newHistoryTitle = container.data("page-history-state-title");

        var currentPath = window.location.pathname;
        var currentHash = window.location.hash;

        if (newHistoryStatePath !== undefined &&
            newHistoryStatePath !== null &&
            newHistoryStatePath.length > 0) {

            if (currentHash.indexOf(newHistoryStatePath) === -1) {

                window.location.hash = newHistoryStatePath;
            }
        }
        else if (currentHash !== '') {
            window.location.hash = '';
        }
    };

    return {
        init: function () {
            if (checkIfContainerOrHashExists()) {
                updatePageHistoryState();
            }
        }
    };

})(window.jQuery);

window.TrilliumPageHistoryState = TrilliumPageHistoryState;
